export default "__VITE_ASSET__DC0xl2iI__"